export const CAP_TABLE_CURRENCY_PAGE = 'captable';
export const FINANCIALS_CURRENCY_PAGE = 'financials';
